import {download, get, post} from "@/utils/http"

export const _selectPages = params => get("/mChat/selectPages", params);
export const _get = params => get("/mChat/get", params);
export const _save = params => post(params.id ? "/mChat/update" : "/mChat/save", params);
export const _delete = params => get("/mChat/delete", params);
export const _print = params => get("/mChat/print", params);

export const _download = params => get("/mChat/download", params);
export const _export = params => download("/mChat/export", params);



